<template>
  <div class="product-page py-0">
    <div class="bg-fixed-100 collection-bg" :class="getBG"></div>
    <div class="black-box"></div>
    <router-link :to="{ name: 'Home'}" @click.native="$emit('headerClick')">
      <img :src="$root.logo" class="main-logo big relative nobg">
    </router-link>
    <Header></Header>
    <div class="content" v-if="product">

      <v-container class="product-container mt-md-12 px-3 px-md-12" fluid>
        <v-row justify="center" class="px-md-16">
          <h2 class="c-red font-kristi text-align-center product-title title-drop-shadow">{{product.name}}</h2>
        </v-row>
        <v-row class="mt-12">
          <v-col cols="12" md="6" class="product px-3 px-md-12">
            <div class="">
              <img class="pa-md-6 pa-1 img-product" :src="product.photosURLBase + mainPhoto">
            </div>
          </v-col>
          <v-col cols="12" md="6" class="pr-md-16 column-container">
            <div class="gallery-parent">
              <div class="gallery-slider" ref="sliderparent">
                <div class="thumbnail-container" :class="{'extended': product.photos.length > 16}" ref="sliderchild">
                  <div class="thumbnail"
                    v-for="(thumb, index) in product.photos"
                    :key="'thumb'+index"
                    :style="{ backgroundImage: 'url(' + product.photosURLBase + thumb + ')' }"
                    @click="mainPhoto = thumb"
                  ></div>
                </div>
              </div>
              <div v-if="product.photos.length > 16" class="arrow right" @click="slideRight"><img :src="arrowright"></div>
              <div v-if="product.photos.length > 16" class="arrow left" @click="slideLeft"><img :src="arrowleft"></div>
            </div>

            <div class="product-cta" @click="showPopup=true;popupType='about'">
              <div class="product-icon sun"></div>
              <h4>ABOUT THIS PRODUCT</h4>
            </div>
            <div class="product-cta" @click="showPopup=true;popupType='contact'">
              <div class="product-icon edelweiss"></div>
              <h4>CONTACT US!</h4>
            </div>
            <div class="product-cta" @click="showPopup=true;popupType='measure'">
              <div class="product-icon train"></div>
              <h4>HOW TO MEASURE?</h4>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="popup-generic" v-if="showPopup">

      <div class="popup-box">
        <iconClose @click="showPopup = false" class="icon-close"></iconClose>

        <div class="info mt-6 " v-if="popupType === 'about' && product.material">
          <p class="font-amita">{{product.text}}</p>
          <h5>Material: <span>{{product.material}}</span></h5>
          <h5>Color: <span>{{product.color}}</span></h5>
          <h5 v-if="product.detail && product.detail !== ''">Detail: <span>{{product.detail}}</span></h5>
          <h5 v-if="product.size && product.size !== ''" class="pointer" @click="showChart = true">Size: <span>{{product.size}}</span></h5>
        </div>

        <div class="measure" v-if="popupType === 'measure' && product.description">
          <h5 class="font-kristi">{{product.description}}</h5>
          <h5 class="mt-6">{{product.footer}}</h5>
          <h5 class="font-kristi">PLEASE NOTE: PRODUCTION WILL REQUIRE AT LEAST 14 WORKING DAYS</h5>
          <a href="./static/instruction.pdf" target="_blank">
            <h4 v-if="product.measurement" class="measure-button font-kristi c-red mt-9">How To Measure</h4>
          </a>
        </div>

        <contact-form v-if="popupType === 'contact'" class="contact"></contact-form>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../organisms/Header.vue'

import Viewport from '@monogrid/vue-lib/lib/mixins/Viewport'

import arrowleft from '@/assets/img/arrow-left.png'
import arrowright from '@/assets/img/arrow-right.png'

import materialPattern from '@/assets/img/material-pattern.jpg'
import descriptionPattern from '@/assets/img/description-pattern.jpg'
import slugify from 'slugify'
import iconClose from '@/assets/svg/cross-icon.svg'
import ContactForm from '../molecules/ContactForm.vue'

export default {
  name: 'Product',

  mixins: [Viewport],

  components: {
    Header, iconClose, ContactForm
  },

  data () {
    return {
      arrowleft,
      arrowright,
      materialPattern,
      descriptionPattern,
      product: null,
      collection: null,
      mainPhoto: null,
      showPopup: false,
      popupType: ''
    }
  },

  mounted () {
    console.log(this.$root.config)
    this.getContent()
  },

  methods: {
    slideLeft () {
      // console.log(this.$refs, this.$refs.sliderchild.offsetLeft, this.$refs.sliderparent.clientWidth)
      this.$refs.sliderparent.scrollLeft -= (this.viewPort.width) * 0.06 + 20
    },
    slideRight () {
      // console.log(this.$refs.sliderchild.left)
      this.$refs.sliderparent.scrollLeft += (this.viewPort.width) * 0.06 + 20
    },
    getContent () {
      for (let i = 0; i < this.$root.config.collection.length; i++) {
        const collection = this.$root.config.collection[i]

        if (collection.products) {
          for (let c = 0; c < collection.products.length; c++) {
            const prod = collection.products[c]
            if (slugify(prod.slug) === this.$route.params.product) {
              this.product = prod
              this.mainPhoto = this.product.photos[0]
              this.collection = collection
            }
          }
        }
      }
    }
  },

  watch: {
    $route () {
      console.log(this.$route.params.product)
      this.getContent()
    }
  },

  computed: {
    getBG () {
      return this.collection ? this.collection.categoryslug.toLowerCase() : ''
    }
  },

  metaInfo: function () {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
.product-cta {
  cursor: pointer;
  margin: 20px;

  div,
  h4 {
    display: inline-block;
    vertical-align: middle;
    color: $c-yellow;
    text-shadow:
      1px 1px 0 $c-red,
      -1px 1px 0 $c-red,
      -1px -1px 0 $c-red,
      1px -1px 0 $c-red;
  }
}

.product-icon {
  width: 125px;
  height: 125px;
  background-size: cover;

  &.sun {
    background-image: url('../assets/img/sign-sun.png');
    animation: rotate 20s infinite linear;
  }

  &.edelweiss {
    background-image: url('../assets/img/sign-edelweiss.png');
    animation: beating 2s infinite;
  }

  &.train {
    background-image: url('../assets/img/sign-train.png');
    animation: waving 2s infinite alternate;
  }
}

.popup-generic {
  position: fixed;
  z-index: 10;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;

  .icon-close {
    position: absolute;
    top: -80px;
    right: -80px;
  }
}

.popup-box {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 60vw;
  height: 60vh;
  resize: both;
  padding: 10px;
  background-color: $c-yellow;
  min-width: 150px;
  min-height: 60px;
  display: grid;
  place-items: center;
  border-image: url('../assets/img/pattern-cow.png') 56 / 28px / 0 round;
  border-width: 28px;
  border-style: solid;
}

.collection-bg {
  background-image: url('../assets/img/collections-coats-bg.jpg');

  &.dress,
  &.accessories {
    background-image: url('../assets/img/collections-dress-bg.jpg');
  }

  &.pyjama {
    background-image: url('../assets/img/collections-pyjama-bg.jpg');
  }

  &.knitwear,
  &.couturecrochet {
    background-image: url('../assets/img/collections-knitwear-bg.jpg');
  }

  &.menaccessories {
    background-image: url('../assets/img/collections-men-accessories-bg.jpg');
  }

  &.mencapes {
    background-image: url('../assets/img/collections-men-capes-bg.jpg');
  }

  &.menjackets {
    background-image: url('../assets/img/collections-men-jackets-bg.jpg');
  }

  &.menknitwear {
    background-image: url('../assets/img/collections-men-knitwear-bg.jpg');
  }

  &.menshirts {
    background-image: url('../assets/img/collections-men-shirts-bg.jpg');
  }

  &.menkaftans {
    background-image: url('../assets/img/collections-men-kaftans-bg.jpg');
  }
}

.product-container {
  width: 100%;
  margin-bottom: 128px;
}

.product {
  position: relative;

  img {
    width: 100%;
    height: auto;
  }

  h4 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
    padding: 10px 40px;
    background-color: $c-red;
    color: #fff;
  }
}

.gallery-parent {
  position: relative;
  width: fit-content;

  .arrow {
    position: absolute;
    top: 50%;
    cursor: pointer;
    display: inline-block;

    img {
      width: 60px;
    }

    &.right {
      right: -60px;
    }

    &.left {
      left: -60px;
    }
  }
}

.gallery-slider {
  width: calc(24vw + 80px);
  overflow: hidden;
  position: relative;
}

.thumbnail-container {
  @include breakpoint('xs-only') {
    display: block;
    height: auto;
  }

  &.extended {
    display: inline-flex;
    flex-direction: column;
    height: calc(24vw + 80px);
    flex-wrap: wrap;
    width: auto;
  }
}

.thumbnail {
  width: 6vw;
  height: 6vw;
  border-radius: 6vw;
  margin: 10px;
  display: inline-block;
  background-color: $c-white;
  background-size: cover;
  background-position: center center;
  cursor: pointer;
  opacity: 1;

  @include breakpoint('xs-only') {
    width: 15vw;
    height: 15vw;
    border-radius: 15vw;
  }

  &:hover {
    border: 2px $c-red solid;
  }
}

.content {
  z-index: 1;
  position: relative;
}

h1 {
  text-align: center;
}

.measure,
.info {
  color: $c-red;
  position: relative;

  h5 span {
    font-weight: normal;
  }
}

.measure-button {
  cursor: pointer;
}

@keyframes rotate {
  from {transform: rotate(0deg);}
  to {transform: rotate(360deg);}
}

@keyframes beating {
  0% {transform: scale(1);}
  90% {transform: scale(1.1);}
  100% {transform: scale(1);}
}

@keyframes waving {
  from {transform: rotate(-30deg);}
  to {transform: rotate(30deg);}
}
</style>
